import React from "react";

import PageRoot from "@refere/ui-utils/ui/components/PageRoot";

import SummaryBox from "../componentes/SummaryBox";
import PassoCertificado from "./componentes/PassoCertificado";

import { useHookstate } from "@hookstate/core";

import { globalState } from "../../features/global-state";

const CertificadoPage = () => {
    const _globalState = useHookstate(globalState);

    return (
        <>
        {
            _globalState.simulacao?.get() &&
            <PageRoot
                leftPanel={{
                    content: <PassoCertificado />,
                }}
                rightPanel={{
                    content: <SummaryBox />,
                    width: "25%"
                }}
            />
        }
        </>
    );
}

export default CertificadoPage;